import { useEffect, useState } from 'react';
import { Users } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../lib/api';

// Founders : même prénom sur plusieurs comptes → on fusionne dans le compte utilisé pour se connecter.
export const DuplicateAccountsPanel = ({ onMerged }) => {
  const [groups, setGroups] = useState([]);
  const load = () => api.get('/users/duplicates').then((r) => setGroups(r.data.groups || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!groups.length) return null;
  const merge = async (group, target) => {
    const others = group.filter((p) => p.id !== target.id && p.role !== 'founder');
    if (!window.confirm(`Tout passer sur « ${target.name} » (${target.email || target.id}) et supprimer ${others.map((o) => o.email || o.id).join(', ')} ?`)) return;
    try {
      let moved = 0;
      for (const o of others) moved += (await api.post('/users/merge', { from_id: o.id, to_id: target.id })).data.moved;
      toast.success(`Comptes fusionnés · ${moved} élément(s) transféré(s) ✓`);
      load(); onMerged?.();
    } catch (err) { toast.error(err?.response?.data?.detail || 'Erreur'); }
  };
  const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }) : 'jamais');
  return (
    <div data-testid="duplicates-panel" style={{ margin: '0 0 18px', padding: 16, borderRadius: 14, background: 'rgba(255,107,107,0.07)', border: '1px solid rgba(255,107,107,0.35)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontFamily: 'Sora', fontWeight: 800, fontSize: 14, color: '#FF8A8A' }}>
        <Users size={16} /> Comptes en double : ces personnes risquent de ne pas voir leurs tâches
      </div>
      <div style={{ fontSize: 12, color: 'var(--t3)', margin: '4px 0 10px' }}>Garde le compte avec lequel la personne se connecte (dernière connexion la plus récente) : ses tâches y seront transférées.</div>
      {groups.map((g, i) => (
        <div key={i} style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
          {g.map((p) => (
            <div key={p.id} data-testid={`dup-account-${p.id}`} style={{ flex: '1 1 220px', padding: '10px 12px', borderRadius: 10, background: 'var(--sf2)', border: '1px solid var(--bd)' }}>
              <div style={{ fontFamily: 'Sora', fontWeight: 700, fontSize: 13 }}>{p.name}</div>
              <div style={{ fontSize: 11.5, color: 'var(--t3)' }}>{p.email || p.id} · {p.task_count} tâche(s) · connecté : {fmt(p.last_login)}</div>
              {(
                <button data-testid={`dup-keep-${p.id}`} onClick={() => merge(g, p)} style={{ marginTop: 8, padding: '6px 10px', borderRadius: 8, cursor: 'pointer', background: 'rgba(52,211,153,0.14)', border: '1px solid rgba(52,211,153,0.4)', color: '#34D399', fontFamily: 'Sora', fontWeight: 700, fontSize: 11.5 }}>Garder ce compte</button>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
